/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_Ogdescription1Inputs */

const en_seo_home_ogdescription1 = /** @type {(inputs: Seo_Home_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every AI tool independently scored on six dimensions, price-checked weekly, and compared against the alternatives — decide on evidence, not marketing.`)
};

const zh_seo_home_ogdescription1 = /** @type {(inputs: Seo_Home_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个 AI 工具独立六维评分、每周核实价格、逐一对比替代方案——先看证据再决定，不靠营销页吹嘘。`)
};

/**
* | output |
* | --- |
* | "Every AI tool independently scored on six dimensions, price-checked weekly, and compared against the alternatives — decide on evidence, not marketing." |
*
* @param {Seo_Home_Ogdescription1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_home_ogdescription1 = /** @type {((inputs?: Seo_Home_Ogdescription1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_Ogdescription1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_home_ogdescription1(inputs)
	return zh_seo_home_ogdescription1(inputs)
});
export { seo_home_ogdescription1 as "seo.home.ogDescription" }